module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-700-bold-af069fac58b08292105e5c6942e21017.woff2";